import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconTemplates = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 32 32"
      data-fill-none
    >
      <path
        d="M24.8888 6H7.1111C6.49746 6 6 6.49746 6 7.1111V12.6666C6 13.2803 6.49746 13.7777 7.1111 13.7777H24.8888C25.5024 13.7777 25.9999 13.2803 25.9999 12.6666V7.1111C25.9999 6.49746 25.5024 6 24.8888 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8888 18.2221H7.1111C6.49746 18.2221 6 18.7196 6 19.3332V24.8887C6 25.5024 6.49746 25.9998 7.1111 25.9998H14.8888C15.5025 25.9998 15.9999 25.5024 15.9999 24.8887V19.3332C15.9999 18.7196 15.5025 18.2221 14.8888 18.2221Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8888 18.2221H21.5554C20.9418 18.2221 20.4443 18.7196 20.4443 19.3332V24.8887C20.4443 25.5024 20.9418 25.9998 21.5554 25.9998H24.8888C25.5024 25.9998 25.9999 25.5024 25.9999 24.8887V19.3332C25.9999 18.7196 25.5024 18.2221 24.8888 18.2221Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
});
IconTemplates.displayName = 'IconTemplates';
